import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const submitPerpayPlusSoloApplicationActions = createDataModuleActions(
    'SUBMIT_PERPAY_PLUS_SOLO_APPLICATION',
);
export const submitPerpayPlusSoloApplication =
    submitPerpayPlusSoloApplicationActions.dataRequest;
export const submitPerpayPlusSoloApplicationSuccess =
    submitPerpayPlusSoloApplicationActions.dataSuccess;
export const submitPerpayPlusSoloApplicationError =
    submitPerpayPlusSoloApplicationActions.dataError;
export const submitPerpayPlusSoloApplicationReset =
    submitPerpayPlusSoloApplicationActions.dataReset;

const createPerpayPlusSoloFeatureEnrollmentActions = createDataModuleActions(
    'CREATE_PERPAY_PLUS_SOLO_FEATURE_ENROLLMENT',
);
export const createPerpayPlusSoloFeatureEnrollment =
    createPerpayPlusSoloFeatureEnrollmentActions.dataRequest;
export const createPerpayPlusSoloFeatureEnrollmentSuccess =
    createPerpayPlusSoloFeatureEnrollmentActions.dataSuccess;
export const createPerpayPlusSoloFeatureEnrollmentError =
    createPerpayPlusSoloFeatureEnrollmentActions.dataError;
export const createPerpayPlusSoloFeatureEnrollmentReset =
    createPerpayPlusSoloFeatureEnrollmentActions.dataReset;

const createPerpayPlusSoloEnrollmentActions = createDataModuleActions(
    'CREATE_PERPAY_PLUS_SOLO_ENROLLMENT',
);
export const createPerpayPlusSoloEnrollment =
    createPerpayPlusSoloEnrollmentActions.dataRequest;
export const createPerpayPlusSoloEnrollmentSuccess =
    createPerpayPlusSoloEnrollmentActions.dataSuccess;
export const createPerpayPlusSoloEnrollmentError =
    createPerpayPlusSoloEnrollmentActions.dataError;
